<template>
    <div ref="container" class="typeform-container">
        <div v-if="typeFormId" :data-tf-live="typeFormId" />
        <div v-else class="loading-state">
            <p>...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "TypeformEmbed",
    props: {
        typeFormId: {
            type: String,
            required: true,
            default: ''
        }
    },
    data() {
        return {
            tfScript: null,
            isScriptLoaded: false
        };
    },
    watch: {
        typeFormId: {
            handler(newId, oldId) {
                if (newId && newId !== oldId) {
                    console.log('🔄 Nuevo typeFormId detectado:', newId);
                    this.reloadTypeform();
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.loadTypeform();
    },
    beforeDestroy() {
        // Limpieza: remover el script si es necesario
        if (this.tfScript && this.tfScript.parentNode) {
            this.tfScript.parentNode.removeChild(this.tfScript);
            this.tfScript = null;
            this.isScriptLoaded = false;
        }
    },
    methods: {
        async loadTypeform() {
            if (!this.typeFormId) {
                console.warn('⚠️ No hay typeFormId disponible');
                return;
            }

            // Solo carga el script una vez
            if (!this.isScriptLoaded) {
                await this.$nextTick();
                
                // Verificar si el script ya existe en el DOM
                const existingScript = document.querySelector('script[src*="embed.typeform.com"]');
                
                if (existingScript) {
                    this.tfScript = existingScript;
                    this.isScriptLoaded = true;
                } else {
                    this.tfScript = document.createElement("script");
                    this.tfScript.src = "//embed.typeform.com/next/embed.js";
                    this.tfScript.async = true;
                    
                    this.tfScript.onload = () => {
                        this.isScriptLoaded = true;
                        this.initializeTypeform();
                    };
                    
                    this.tfScript.onerror = () => {
                        console.error('❌ Error al cargar el script de Typeform');
                    };
                    
                    document.body.appendChild(this.tfScript);
                }
            }

            // Mostrar el contenedor
            if (this.$refs.container) {
                this.$refs.container.style.display = "block";
            }
        },
        
        async reloadTypeform() {
            // Si el ID cambia, reinicializar
            await this.$nextTick();
            this.initializeTypeform();
        },
        
        initializeTypeform() {
            // Forzar la reinicialización del embed
            if (this.$refs.container && this.typeFormId) {
                console.log('🎯 Inicializando Typeform con ID:', this.typeFormId);
                
                // Si existe window.tf, reinicializar
                if (window.tf && window.tf.createWidget) {
                    window.tf.createWidget(this.typeFormId, {
                        container: this.$refs.container.querySelector('[data-tf-live]')
                    });
                }
            }
        }
    }
};
</script>

<style scoped>
.typeform-container {
    width: 100%;
    min-height: 500px;
    position: relative;
}

.typeform-container [data-tf-live] {
    width: 100%;
    height: 100%;
    min-height: 500px;
}

.loading-state {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    color: #6b7280;
}

/* Asegurar que el iframe de Typeform ocupe todo el espacio */
.typeform-container iframe {
    width: 100% !important;
    min-height: 500px !important;
    border: none;
}
</style>